import { MartBreakdownRow } from 'src/redux/admin/mart-reporting/mart-reporting.types';
import {
  BreakdownKind,
  formatBreakdownValue,
} from 'src/pages/reports/utils/format-reporting-labels';
import { BetaChartCard } from './beta-chart-card';
import { BetaBreakdownTableSkeleton } from './beta-chart-skeletons';

interface BetaBreakdownTableProps {
  title: string;
  subtitle?: string;
  data: MartBreakdownRow[];
  breakdownField?: string;
  breakdownKind?: BreakdownKind;
  /** @deprecated Use breakdownField */
  geoField?: string;
  metricKey?: string;
  colour?: string;
  isLoading?: boolean;
}

const formatValue = (value: number) => value.toLocaleString(undefined, { maximumFractionDigits: 0 });

export function BetaBreakdownTable({
  title,
  subtitle,
  data,
  breakdownField,
  breakdownKind = 'geo',
  geoField,
  metricKey = 'impressions',
  colour = '#2563EB',
  isLoading = false,
}: BetaBreakdownTableProps) {
  const field = breakdownField ?? geoField ?? '';
  const rows = data.slice(0, 10);
  const maxValue = Math.max(...rows.map((row) => Number(row[metricKey] ?? 0)), 1);

  return (
    <BetaChartCard title={title} subtitle={subtitle}>
      {isLoading ? (
        <BetaBreakdownTableSkeleton colour={colour} />
      ) : rows.length === 0 ? (
        <div className="py-10 text-center text-sm text-[#8A8EA0]">No rows to display.</div>
      ) : (
        <table className="w-full border-collapse text-[12.5px]">
          <tbody>
            {rows.map((row) => {
              const value = Number(row[metricKey] ?? 0);
              const width = `${Math.max((value / maxValue) * 100, 4)}%`;
              const rawKey = String(row.key ?? '');
              const displayLabel = formatBreakdownValue(breakdownKind, field, rawKey);
              return (
                <tr key={rawKey}>
                  <td className="border-b border-[#EDEEF2] py-2 pr-3 align-middle">
                    <span className="inline-block h-2 w-2 rounded-full mr-2" style={{ backgroundColor: colour }} />
                    <span
                      className="font-semibold text-[#0D0F1A]"
                      title={displayLabel !== rawKey ? rawKey : undefined}
                    >
                      {displayLabel}
                    </span>
                    <div className="mt-1 h-1 rounded-sm bg-[#EDEEF2]">
                      <div className="h-1 rounded-sm" style={{ width, backgroundColor: colour }} />
                    </div>
                  </td>
                  <td className="border-b border-[#EDEEF2] py-2 text-right align-middle font-mono text-[11.5px] font-semibold text-[#0D0F1A]">
                    {formatValue(value)}
                  </td>
                  <td className="border-b border-[#EDEEF2] py-2 pl-3 text-right align-middle text-[11px] text-[#9CA3AF]">
                    {formatValue(Number(row.impressions ?? 0))} impr
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </BetaChartCard>
  );
}
